var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',_vm._b({},'font-awesome-icon',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }